<template>
<app-content>
  <h1>Om Tripply</h1>
  <p>Om om om</p>
</app-content>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppContent from '@/components/layout/AppContent.vue'

export default defineComponent({
  components: { AppContent },
  setup() {
    return { }
  }
})
</script>

<style>

</style>